import { useQuery } from 'react-query'
import request from 'superagent'
import { getApiServer } from '../../utils/domain'

interface Payload {
  resource?: string;
  pagesOffset?: string;
  pageState?: string;
  resourceId?: string | undefined;
  searchTerms?: Record<string, string | number> | string
  pageSize?: number;
  drugLetter?: string | undefined;
}

export default function useFullProviderFhirResource(payload: Payload): any {
  return useQuery(
    ['provider-resource-all',
        payload.resource,
        payload.searchTerms,
        payload.pageSize,
        payload.drugLetter],
    async () => {
      const res = await request
        .get(`${getApiServer()}/fhir/provider-resource/full`)
        .query({ ...payload })
        .set('Accept', 'application/json')

      return res.body
    },
    {
      staleTime: Infinity,
      cacheTime: 5 * 60 * 1000,
      retry: 0,
      keepPreviousData: true,
      enabled: false
    }
  )
}